<template>
  <div class="edit">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <b>
          {{ isCreate ? '新建广告位(Create New Ad Slot)': '编辑广告位(Edit New Ad Slot)'}}
        </b>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div v-if="detail.autoCreate === 1" class="auto-create-tip">
      <p>若未传递Tagid时，ADX广告位仅支持使用兜底广告位。请您检查是否已传递Tagid。</p>
      <p>If no Tagid is provided, the ADX ad slot will only use a fallback ad slot. Please check if a Tagid has been passed.</p>
    </div>
    <el-form class="detail" ref="form" :model="detail" label-width="310px" :rules="rule">
      <el-form-item style="margin-top: 20px" v-for="item in formConfig" :key="item.prop" :label="item.label" :prop="item.prop">
        <el-select
            v-if="item.prop === 'mediaId'"
            v-model="detail[item.prop]"
            filterable
            placeholder="请选择所属媒体/Select Belonged Media"
            :disabled="!isCreate"
        >
          <el-option v-for="option in mediaList" :key="option.id" :value="option.id" :title="`${option.id}-${option.name}`" :label="`${option.id}-${option.name}`"/>
        </el-select>
        <el-select
            v-else-if="item.prop === 'adResourceType'"
            v-model="detail[item.prop]"
            filterable
            placeholder="请选择广告位资源类型/Select Ad Slot Type"
            :disabled="!isCreate"
        >
          <el-option v-for="option in adSlotResourceList" :key="option.id" :value="option.id" :label="option.name"/>
        </el-select>
        <el-radio-group v-else-if="item.prop === 'status'" v-model="detail[item.prop]" :disabled="detail[item.prop] === -1">
          <el-radio v-for="type in computedStatus" :label="type.id" :key="type.id">{{ type.name }}</el-radio>
        </el-radio-group>
        <el-checkbox-group v-else-if="item.prop === 'materialTypeList'" v-model="detail[item.prop]">
          <el-checkbox v-for="type in materialList" :label="type.id" :key="type.id">
            {{ type.name }}
          </el-checkbox>
        </el-checkbox-group>
        <el-checkbox-group v-else-if="item.prop === 'aspectRatioList'" v-model="detail[item.prop]">
          <el-checkbox v-for="type in proportionList" :label="type.value" :key="type.value">
            {{ type.value }}
          </el-checkbox>
        </el-checkbox-group>
        <el-radio-group v-else-if="item.prop === 'reservePriceSetting'" v-model="detail[item.prop]" @change="handleReservePriceSettingChange">
          <el-radio v-for="type in pricingStrategyList" :label="type.id" :key="type.id">{{ type.name }}</el-radio>
        </el-radio-group>
        <el-input-number
            v-else-if="item.prop === 'reservePrice'"
            v-model="detail[item.prop]"
            clearable
            placeholder="请输入底价 美元/千次曝光/Input Price USD/Mille"
            :min="0"
            :max="99999999"
            :precision="2"
            :controls="false"/>
        <el-input
            v-else
            v-model="detail[item.prop]"
            clearable
            :disabled="(['id', 'site', 'account'].includes(item.prop))"
            :placeholder="placeholderText(item.label)"
            :type="item.type"
            :maxlength="item.maxLength || null"
            :rows="5"/>
        <div class="item-tip" v-if="item.tip" v-html="item.tip"/>
      </el-form-item>
      <el-form-item class="bottom-button">
        <el-button @click="$router.push({name: 'adzone'})">取消(Cancel)</el-button>
        <el-button type="primary" @click="save">确认(Confirm)</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {placeholderText} from '@/tools/common-utils';
import {ADSlotTypeEnum, StatusEnum, PricingStrategyEnum, MaterialTypeEnum, ProportionTypeEnum} from '@/enums/enums';
import {sspApi} from '@/api';

export default {
  data: function () {
    return {
      statusList: Object.values(StatusEnum),
      // 广告位资源类型
      adSlotResourceList: Object.values(ADSlotTypeEnum),
      // 价格策略设置
      pricingStrategyList: Object.values(PricingStrategyEnum),
      // 素材类型
      materialList: [],
      // 素材比例
      proportionList: [],
      // 所属媒体
      mediaList: [],
      detail: {
        id: undefined,
        name: '',
        mediaId: undefined,
        status: 1,
        adResourceType: undefined,
        materialTypeList: [],
        aspectRatioList: [],
        reservePriceSetting: 1,
        reservePrice: undefined,
      },
      config: [
        {prop: 'id', label: '广告位ID(Ad Slot ID)', type: 'text'},
        {prop: 'name', label: '广告位名称(Ad Slot Name)', type: 'text', maxLength: 50},
        {prop: 'mediaId', label: '所属媒体(Belonged Media)'},
        {prop: 'status', label: '状态(Status)'},
        {prop: 'adResourceType', label: '广告位资源类型(Ad Slot Type)'},
        {prop: 'materialTypeList', label: '素材类型(Ad Material Type) '},
        {prop: 'aspectRatioList', label: '素材比例(Ad Proportion Type) '},
        {
          prop: 'adxAdzoneList',
          label: '兜底广告位标识(Tag_id) (bottom-line tag_id)',
          maxLength: 500
        },
        {prop: 'reservePriceSetting', label: '价格策略设置(Pricing Strategy Setting)'},
        {prop: 'reservePrice', label: '', type: 'text'},
        {prop: 'description', label: '广告位描述 (Description)', type: 'textarea', maxLength: 500}
      ],
      rule: {
        name: [{required: true, message: '请输入广告位名称/Input Ad Slot Name', trigger: 'blur'}],
        adResourceType: [{required: true, message: '请选择广告位资源类型/Select Ad Slot Type', trigger: 'change'}],
        mediaId: [{required: true, message: '请选择所属媒体/Select Belonged Media', trigger: 'change'}],
        materialTypeList: [{required: true, message: '请选择素材类型/Select Ad Material Type', trigger: 'change'}],
        aspectRatioList: [{required: true, message: '请选择比例/Select Ad Proportion Type', trigger: 'change'}],
        reservePrice: [{required: true, message: '请输入底价 美元/千次曝光/Input Price USD/Mille', trigger: 'blur'}]
      }
    }
  },
  created: function () {
    sspApi.getAdzoneConfig({params: {adzoneId: this.adzoneId}}).then(({ mediaList = [], adzone }) => {
      this.mediaList = mediaList;
      if (adzone) {
        this.detail = {
          ...this.detail,
          ...adzone,
          site: `${adzone.siteId}-${adzone.siteName}`,
          account: `${adzone.accountId}-${adzone.accountName}`,
          reservePriceSetting: adzone.reservePrice === null ? PricingStrategyEnum.DYNAMIC.id: PricingStrategyEnum.STATIC.id
        };
      }
    }).catch(this.$rejectAjaxError());
  },
  methods: {
    placeholderText,
    handleReservePriceSettingChange: function () {
      this.detail.reservePrice = undefined;
    },
    save: function () {
      this.$element.checkForm(this.$refs.form);
      this.$confirm('确认提交(Confirm and Submit)？', '', {
        confirmButtonText: '确认(Confirm)',
        cancelButtonText: '取消(Cancel)',
        type: 'info'
      }).then(() => {
        sspApi.editAdzone({data: this.detail}).then(() => {
          this.$router.push({name: "adzone"});
        }).catch(this.$rejectAjaxError());
      }).catch(() => {});

    }
  },
  watch: {
    'detail.mediaId'(newVal) {
      const media = this.mediaList.find(item => item.id === newVal);
      if (media) {
        this.detail.site = `${media.siteId}-${media.siteName}`;
        this.detail.account = `${media.accountId}-${media.accountName}`;
        this.detail.accountId = media.accountId;
      } else {
        this.detail.site = '';
        this.detail.account = '';
      }
    },
    'detail.adResourceType'(newVal) {
      switch (newVal) {
        case ADSlotTypeEnum.INTERSTITIAL.id:
        case ADSlotTypeEnum.REWARD_VIDEO.id:
          this.materialList = [MaterialTypeEnum.VIDEO]
          this.proportionList = [ProportionTypeEnum.VERTICAL, ProportionTypeEnum.HORIZONTAL]
          break;
        case ADSlotTypeEnum.NATIVE.id:
          this.materialList = Object.values(MaterialTypeEnum)
          this.proportionList = [ProportionTypeEnum.VERTICAL, ProportionTypeEnum.HORIZONTAL, ProportionTypeEnum.SQUARE]
          break;
        case ADSlotTypeEnum.BANNER.id:
          this.materialList = [MaterialTypeEnum.IMAGE]
          this.proportionList = [ProportionTypeEnum.BANNER, ProportionTypeEnum.PORTRAIT]
          break;
      }
    }
  },
  computed: {
    adzoneId: function () {
      return this.$route.params.adzoneId
    },
    isCreate: function () {
      return this.adzoneId === undefined
    },
    formConfig() {
      return this.config.filter(item => {
        if (!this.detail.adResourceType && ['materialTypeList', 'aspectRatioList'].includes(item.prop)) {
          return false;
        }
        if(this.isCreate && ['id'].includes(item.prop)) {
          return false;
        }
        // 动态底价隐藏价格填写
        return !(item.prop === 'reservePrice' && this.detail.reservePriceSetting === PricingStrategyEnum.DYNAMIC.id);
      });
    },
    computedStatus() {
      return this.detail.status === -1 ? this.statusList : this.statusList.filter(item => item.id !== -1)
    }
  }
}
</script>
<style scoped>
.detail {
  font-size: 10px;
  padding-left: 20px;
}

.detail >>> .el-col {
  height: 30px;
  width: 40%;
}

.detail >>> .el-input, .detail >>> .el-textarea {
  width: 350px;
}

.desc {
  height: 110px;
}

.desc >>> .el-input__inner {
  height: 200px;
}

.detail span {
  margin-left: 10px;
  color: red
}

.bottom-button {
  width: 660px;
  text-align: right;
}

.detail >>> .el-input-number .el-input__inner {
  text-align: left;
}

.item-tip {
  color: #909399;
}

.auto-create-tip {
  margin-top: 20px;
  font-size: 14px;
  background-color: cornsilk;
  padding: 10px;
  width: 780px;
  border-radius: 3px;
}
</style>
